import React, { useState, useEffect, createContext, useMemo } from "react";
import NotificationHistoryTemplate from "./component/templates/NotificationHistoryTemplate";
import BaseApi from "../../functions/axios";

export const notificationContext = createContext({ notificationList: [] });

export default function NotificationHistory() {
  const [notificationList, setNotificationList] = useState([]);

  useEffect(() => {
    BaseApi.get("notification_all")
      .then((res) => {
        setNotificationList(res?.data?.data?.notification_list || []);
      })
      .catch((error) => console.error("notification_all error:", error));
  }, []);

  const contextValues = useMemo(
    () => ({ notificationList }),
    [notificationList]
  );

  return (
    <notificationContext.Provider value={contextValues}>
      <NotificationHistoryTemplate />
    </notificationContext.Provider>
  );
}